import React, { useEffect, useState } from "react";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import { Col, Row } from "antd";
import { useParams } from "react-router-dom";
import BackWithLabel from "@/components/common/BackWithLabel";
import "@/styles/pages/guide/day-availability.scss";
import { getUserAvailability } from "@/services/users/getUserAvailability";
import { useDispatch } from "react-redux";
import TimeSlotSelector from "@/pages/guide/panel/availability/TimeSlotSelector";
import { updateUserAvailability } from "@/services/users/updateUserAvailability";
import {
  convertTimeRangesToUTC,
  convertUTCRangesToLocal,
  getSlotDifferences,
  transformTimeSlots,
} from "@/services/luxon";

const DayAvailibility = () => {
  const { id } = useParams();
  const [slotData, setSlotData] = useState([]);
  const [savedLocalSlotData, setSavedLocalSlotData] = useState([]);
  const dispatch = useDispatch();

  const fetchData = () => {
    getUserAvailability(id)
      .then((res) => {
        const convertToLocalTime = convertUTCRangesToLocal(res);
        setSavedLocalSlotData(convertToLocalTime);
        const finalSlots = convertToLocalTime[id] || [];
        finalSlots.forEach((slot) => {
          if (slot.start === "00:00" && slot.end === "00:00") {
            slot.end = "24:00";
          }
        });
        console.log(finalSlots);
        setSlotData(finalSlots);
        console.log("Final Slots:", finalSlots);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const onUpdateAvailability = async (ranges, isReset, dayToUpdate) => {
    const day = dayToUpdate || id;
    if (dayToUpdate) console.log("previous timeslots in Local:", savedLocalSlotData);
    if (isReset) {
      ranges = [
        {
          start: "00:00",
          end: "24:00",
        },
      ];
    }
    const groupedTimeslotsInUTC = convertTimeRangesToUTC(day, ranges);
    const payloads = transformTimeSlots(groupedTimeslotsInUTC);

    if (isReset) {
      try {
        await Promise.all(
          payloads.map((payload) =>
            updateUserAvailability({
              ...payload,
              action: "remove",
            })
          )
        );
        console.log("All requests completed successfully.");
      } catch (err) {
        console.error("Error in API calls:", err);
      }
    } else {
      const { deletedSlots, newSlots } = getSlotDifferences(ranges, savedLocalSlotData[day]);
      const deletePayloads = transformTimeSlots(convertTimeRangesToUTC(day, deletedSlots));
      console.log("deletePayloads:", deletePayloads);
      const newAddPayloads = transformTimeSlots(convertTimeRangesToUTC(day, newSlots));
      console.log("newAddPayloads:", newAddPayloads);
      try {
        await Promise.all(
          newAddPayloads.map((payload) =>
            updateUserAvailability({
              ...payload,
              action: "add",
            })
          )
        );
        await Promise.all(
          deletePayloads.map((payload) =>
            updateUserAvailability({
              ...payload,
              action: "remove",
            })
          )
        );
        console.log("All requests completed successfully.");
      } catch (err) {
        console.error("Error in API calls:", err);
      }
    }
  };

  return (
    <div className="day-availibilty-wrapper">
      <Container>
        <CardComponent>
          <Row justify={"space-between"}>
            <Col xxl={24}>
              <div className="heading">
                <BackWithLabel label={`Schedule ${id}`} path="/availability" />
              </div>
            </Col>
            <Col xs={24} className="availibilty-Wrapper">
              <TimeSlotSelector
                initialTimeSlots={slotData}
                onUpdateAvailability={onUpdateAvailability}
                day={id}
                savedLocalSlotData={savedLocalSlotData}
                fetchData={fetchData}
              />
              {/* <Flex vertical gap="10px" className="availibity-icon">
                <ButtonComponent
                  shape="circle"
                  className={!slotData?.length ? "clone" : ""}
                  varient={!slotData?.length ? "" : "primary"}
                  disabled={!slotData?.length}
                  onClick={handleCloneSession}
                  icon={
                    <IconCopy color={!slotData?.length ? "#000" : "#fff"} />
                  }
                />
              </Flex> */}
            </Col>
          </Row>
        </CardComponent>
      </Container>
    </div>
  );
};

export default DayAvailibility;
